import _ from 'lodash'
import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client/core'
import MeQuery from '@/gql/queries/MeQuery.gql'

const apolloClient = new ApolloClient({
    link: createHttpLink({
        uri: process.env.MIX_GRAPHQL_URL,
        headers: {
            authorization: localStorage.getItem(process.env.MIX_APOLLO_TOKEN_NAME) || 'apollo-token'
        },
    }),
    cache: new InMemoryCache(),
})

const getCurrentUser = async function() {
    return apolloClient.query({
        query: MeQuery
    })
}

/**
 * Initialize currentUser using a fresh user class.
 */

class User {
    constructor(user = null) {
        if (user) {
            // @apollo/client 3 rend les résultats de requête immuables (figés).
            // Ce constructeur enrichit la donnée (team.address, subteams...) -> on clone d'abord.
            user = $_.cloneDeep(user)
            const gates = user.currentTeamPivot.gates

            $_.forEach(user, (value, key) => this[key] = value)
            // Somehow, these values aren't set by the forEach method
            this.is_smart_admin = user.is_smart_admin
            this.has_verified_email = user.has_verified_email
            this.current_team_id = user.current_team_id
            this.phone = user.phone
            this.profile_role = user.profile_role
            this.notify_for = user.notify_for
            this.email_frequency = user.email_frequency

            this.team = user.currentTeam

            this.team.subteams.map(subteam => {
                subteam.address = subteam.billingAddress.address
                subteam.city = subteam.billingAddress.city
                subteam.zip = subteam.billingAddress.zip
                return subteam
            })

            if (this.team) {
                this.team.length = this.team.users_count
                this.team.manager = this.team.manager_name
                this.team.manager_phone = this.team.manager_phone
                this.team.manager_logo = this.team.manager_logo
                this.team.address = this.team.billingAddress.address
                this.team.city = this.team.billingAddress.city
                this.team.zip = this.team.billingAddress.zip
                this.all_teams = [this.team, ...this.team.subteams]
            }

            this.exists = user !== null
            this.gates = gates
            this.isAdmin = gates.includes('is_admin')
            this.isPrestataire = this.team.is_prestataire
            this.isClient = ! this.isPrestataire
            this.isSales = this.team.is_sales
            this.isAccounting = this.team.is_accounting
            this.isOnboarded = this.team.is_onboarded
            this.isSmartAdmin = user.is_smart_admin
            this.hasAsksPermission =
                gates.includes('is_admin') || gates.includes('asks') || this.isSmartAdmin
            this.hasBillingAccess = (this.isAccounting || this.isSmartAdmin)
                && (
                    gates.includes('is_admin')
                    || gates.includes('billing')
                    || this.isSmartAdmin
                )
            this.image_url = user ? user.image_url : null
            this.is_active = this.team.is_active
            this.isQuoteModerator = this.isAdmin || gates.includes('is_quote_moderator')
            this.hasClients = this.team.customers_count > 0
            this.hasExternalBillingAccess = this.team.has_external_billing_access
        } else {
            this.team = null
            this.is_admin = null
            this.is_smart_admin = null
            this.user = null
            this.user_gates = null
        }
    }
}

export { getCurrentUser, User }
